import { useModalAction } from '@components/common/modal/modal.context'
import OrderIcon from '@components/icons/order-icon'
import Alert from '@components/ui/alert'
import Button from '@components/ui/button'
import CloseButton from '@components/ui/close-button'
import Input from '@components/ui/form/input'
import Image from '@components/ui/image'
import Logo from '@components/ui/logo'
import { getTrackOrderData } from '@framework/order/order-status'
import cn from 'classnames'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import OrderTrackingInfo, { formatDate } from './order-tracking-info'
import { COUNTRY_ID, ORDER_TRACKING } from '@constants/index'
import SVGIcon from '@components/svg-icon'
import RelatedProductFeed from '@components/product/feeds/related-product-feed'

interface FormInputs {
  email: string
  orderId: string
}
interface SignUpFormProps {
  isPopup?: boolean
  className?: string
  relatedItems?: String[]
}

type Option = {
  label: string
  value: string
}
interface Credentials {
  email: string
  orderId: string
}

type OrderQueryParams = {
  orderid: string
  email: string
}
const breakpoints = {
  '1536': {
    slidesPerView: 6,
  },
  '1280': {
    slidesPerView: 5,
  },
  '1024': {
    slidesPerView: 4,
  },
  '640': {
    slidesPerView: 3,
  },
  '360': {
    slidesPerView: 2,
  },
  '0': {
    slidesPerView: 1,
  },
}

export default function OrderForm({
  isPopup = true,
  className,
  relatedItems,
}: SignUpFormProps) {
  const { t: translate } = useTranslation(['common', 'trackorder', 'forms'])

  const { closeModal, openModal } = useModalAction()
  const router = useRouter()
  const { orderid, email: orderEmail } = router.query as OrderQueryParams
  const [notStarted, setNotStarted] = useState(false)
  const [inprogress, setInprogress] = useState(false)
  const [trackingInfo, setTrackingInfo] = useState<any>()

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch, // ✅ Use watch to track input values
    formState: { errors },
  } = useForm<FormInputs>({
    defaultValues: {
      email: orderEmail || '',
      orderId: orderid || '',
    },
  })
  // Watch values
  const email = watch('email')
  const orderId = watch('orderId')
  const { data, isError, isLoading, mutate } = useMutation<
    any,
    Error,
    Credentials
  >(getTrackOrderData, {
    onSuccess: (data) => {
      setTrackingInfo(data)
      reset()
    },
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const type = e.target.dataset.valueType as 'email' | 'orderId' // Explicit type assertion
    const value = e.target.value
    setValue(type, value)
  }

  useEffect(() => {
    if (orderid && orderEmail) {
      setValue('orderId', orderid)
      setValue('email', orderEmail)
    }
  }, [orderid, orderEmail]) // ✅ Optimized

  useEffect(() => {
    if (data?.length) setTrackingInfo(data)
  }, [data])

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    mutate({ email: data.email, orderId: data.orderId })
  }
  const [trackingIDS, setTrackIDS] = useState<string[]>([])
  const [selectedID, setSelectedID] = useState('')
  const [trackData, setTrackData] = useState({})
  const [selectedIndex, setSelectedTracking] = useState(null)
  const handleTrackingSelection = useCallback(
    (trackingData: any) => {
      setSelectedTracking(trackingData)
    },
    [setSelectedTracking],
  )

  useEffect(() => {
    if (trackingInfo && trackingInfo.length > 0) {
      const trackingData: { [key: string]: any } = {}
      const firstTrackingInfo = trackingInfo[0]

      if (firstTrackingInfo && firstTrackingInfo.tracking_info) {
        Object.keys(firstTrackingInfo.tracking_info).forEach((trackingId) => {
          const { track_data, ...items } =
            firstTrackingInfo.tracking_info[trackingId]
          const { tracking, ...otherData } = track_data

          trackingData[tracking] = {
            trackingID: tracking,
            trackData: otherData,
            items: items?.items,
          }
        })

        const trackingDataKeys: string[] = Object.keys(trackingData)
        if (trackingDataKeys.length > 0) {
          setTrackIDS(trackingDataKeys)
          setSelectedID(trackingDataKeys[0])
          setTrackData(trackingData)
        }
      }
      const { tracking_info, order_info } = firstTrackingInfo
      const { increment_id, status, create_at } = order_info
      if (tracking_info && !Object.keys(tracking_info).length) {
        setNotStarted(true)
      } else if (tracking_info || Object.keys(tracking_info).length) {
        Object.values(tracking_info).map((trackingDetail: any) => {
          let { status } = trackingDetail.track_data
          if (status !== 'delivered') {
            // setInprogress(true)
          } else setInprogress(false)
        })
        setNotStarted(false)
      }
    }
  }, [trackingInfo])

  return (
    <>
      <div
        className={cn(
          `flex bg-brand-light mx-auto rounded-lg ${
            !!trackingInfo ? 'max-w-screen-2xl' : 'max-w-screen-xl'
          }`,
          // className
        )}
      >
        {isPopup === true && <CloseButton onClick={closeModal} />}
        {!!trackingInfo ? (
          <>
            <div className="flex w-full mx-auto gap-10 flex-wrap lg:flex-nowrap">
              <div className="w-full lg:w-[100%] xl:w-[66%] registration relative ">
                <div className="">
                  <OrderTrackingInfo
                    tracking_info={trackingInfo[0].tracking_info}
                    onSelectTracking={handleTrackingSelection}
                    order_info={trackingInfo[0]?.order_info}
                    notStarted
                    inprogress
                    shipping_address={trackingInfo[0]?.shipping_address}
                  />

                  {notStarted && (
                    <>
                      <div className="flex flex-col xl:flex-row gap-10">
                        <div className="border-border-base font-sofia   text-brand-dark shadow-trackorderBox relative rounded-md xl:max-w-xs flex-1 group address__box">
                          <h3 className="font-normal text-xl  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                            {translate('order', { ns: 'trackorder' })}:
                            <span className="font-normal">
                              #{trackingInfo[0]?.order_info?.increment_id}
                            </span>
                          </h3>
                          <div className=" px-6 p-1 pb-6">
                            <div className="font-normal mb-10  text-[15px]">
                              {translate('ordered-on', { ns: 'trackorder' })}:{' '}
                              {formatDate(
                                trackingInfo[0]?.order_info?.create_at.split(
                                  ' ',
                                )[0],
                                trackingInfo[0]?.order_info?.create_at.split(
                                  ' ',
                                )[1],
                              )}
                            </div>
                            <h3 className="font-normal text-sm  text-[15px]">
                              {translate('status', { ns: 'trackorder' })}:{' '}
                              <span
                                className={`  
            ${
              notStarted
                ? 'text-brand-danger'
                : inprogress
                ? 'text-yellow-100'
                : 'text-brand-green'
            }`}
                              >
                                {notStarted
                                  ? 'Not Shipped Yet'
                                  : inprogress
                                  ? 'In Progress'
                                  : 'Delivered'}
                              </span>
                            </h3>
                          </div>
                        </div>
                        <div
                          className="border-border-base  text-brand-dark relative rounded-md  shadow-trackorderBox flex-1 group address__box"
                          id="headlessui-radiogroup-option-:r1h:"
                        >
                          <h3 className="font-normal text-xl font-sofia  bg-brand-darkblue py-2 rounded-tl-lg rounded-tr-lg text-white text-center ">
                            {translate('shipping-address', {
                              ns: 'trackorder',
                            })}
                          </h3>
                          <div
                            className="text-[15px] px-6 p-1 "
                            id="headlessui-description-:r1j:"
                          >
                            <div>
                              {trackingInfo[0]?.shipping_address?.firstname}{' '}
                              {trackingInfo[0]?.shipping_address?.lastname}
                            </div>
                            <div>
                              {' '}
                              {trackingInfo[0]?.shipping_address?.street},{' '}
                            </div>
                            <div>
                              {trackingInfo[0]?.shipping_address?.city?.toUpperCase()}
                            </div>
                            <div>
                              {trackingInfo[0]?.shipping_address?.region} -{' '}
                              {trackingInfo[0]?.shipping_address?.postcode}
                            </div>
                            <div>
                              {trackingInfo[0]?.shipping_address?.telephone}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="border-2  mb-3 lg:mt-5 rounded-md  flex items-center justify-center cursor-pointer min-h-[112px]">
                        <h3 className="mb-2 p-2 md:p-0 md:text-2xl flex items-center text-brand-danger font-medium">
                          <span className="mr-4">
                            <OrderIcon />
                          </span>
                          {translate('order-not-shipped', { ns: 'trackorder' })}
                        </h3>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-[100%] xl:w-[30%]">
                <div className="  rounded-[15px] shadow-trackorderBox border-border-base pt-10 pb-10  px-10 sm:px-8 mb-5 h-80">
                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="flex flex-col justify-center"
                    noValidate
                  >
                    <div className="flex flex-col space-y-8">
                      <Input
                        type="email"
                        data-value-type="email"
                        icon={
                          <SVGIcon
                            icon="envelope"
                            width={18}
                            height={18}
                            className="text-brand-darkblue"
                          />
                        }
                        placeholder="Enter Order Email"
                        variant="solid"
                        {...register('email', {
                          required: `${translate('email-required', {
                            ns: 'forms',
                          })}`,
                          pattern: {
                            value:
                              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            message: translate('email-error', { ns: 'forms' }),
                          },
                        })}
                        error={errors.email?.message}
                        maxLength={50}
                        value={email} // ✅ Shows the value in the input
                        onChange={handleChange} // ✅ Updates value & triggers validation
                      />

                      <Input
                        type="text"
                        placeholder="Enter Order ID"
                        icon={
                          <SVGIcon
                            icon="packingBox"
                            width={18}
                            height={18}
                            className="text-brand-darkblue"
                          />
                        }
                        variant="solid"
                        {...register('orderId', {
                          required: `${translate('order-id-required', {
                            ns: 'forms',
                          })}`,
                        })}
                        error={errors.orderId?.message}
                        data-value-type="orderId"
                        value={orderId} // ✅ Shows the value in the input
                        onChange={handleChange} // ✅ Updates value & triggers validation
                      />

                      <div className="relative">
                        <Button
                          type="submit"
                          loading={isLoading}
                          disabled={isLoading}
                          className="w-full  tracking-normal rounded-[10px] h-11 md:h-12 font-15px md:font-15px"
                          variant="formButton"
                        >
                          {translate('order-status', { ns: 'common' })}
                        </Button>
                      </div>
                      {!!isError && (
                        <Alert message="Please enter correct email and order id to get details" />
                      )}
                    </div>
                  </form>
                </div>
                <div className="py-6  px-4 sm:px-8   rounded-[15px] shadow-trackorderBox">
                  <div className="flex text-brand-dark font-semibold text-sm   items-center justify-around">
                    <Image
                      src="/assets/images/user_contact.png"
                      alt={translate('text-contact-user', { ns: 'common' })}
                      width={60}
                      height={60}
                      quality={100}
                    />
                    <p className="ml-2">
                      {translate('any-quesiton', { ns: 'trackorder' })}
                    </p>
                  </div>
                  <p className="text-sm text-brand-dark p-2">
                    {translate('please-visit', { ns: 'trackorder' })}{' '}
                    <span className="underline text-brand cursor-pointer">
                      {translate('help-center', { ns: 'trackorder' })}
                    </span>{' '}
                    {translate('to-get-support', { ns: 'trackorder' })}
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col md:flex-row w-full  justify-between items-start">
            <div className="w-full lg:w-[45%] xl:w-[40%] md:max-w-[482px]">
              <div className=" mb-6 pt-2.5">
                <div onClick={closeModal}></div>
                <h4 className="text-xl font-semibold text-brand-dark  ">
                  {translate('check-order-status', { ns: 'trackorder' })}
                </h4>
              </div>
              <div className=" shadow-trackorderBox rounded-2xl p-10    flex flex-col justify-center">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="flex flex-col justify-center"
                  noValidate
                >
                  <div className="flex flex-col space-y-4">
                    <Input
                      type="email"
                      data-value-type="email"
                      icon={
                        <SVGIcon
                          icon="envelope"
                          width={18}
                          height={18}
                          className="to-brand-lightgray"
                        />
                      }
                      placeholder="Enter Order Email"
                      variant="solid"
                      {...register('email', {
                        required: `${translate('email-required', {
                          ns: 'forms',
                        })}`,
                        pattern: {
                          value:
                            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                          message: translate('email-error', { ns: 'forms' }),
                        },
                      })}
                      error={errors.email?.message}
                      maxLength={50}
                      value={email} // ✅ Shows the value in the input
                      onChange={handleChange} // ✅ Updates value & triggers validation
                    />

                    <Input
                      type="text"
                      placeholder="Enter Order ID"
                      icon={
                        <SVGIcon
                          icon="packingBox"
                          width={18}
                          height={18}
                          className="to-brand-lightgray"
                        />
                      }
                      variant="solid"
                      {...register('orderId', {
                        required: `${translate('order-id-required', {
                          ns: 'forms',
                        })}`,
                      })}
                      error={errors.orderId?.message}
                      data-value-type="orderId"
                      value={orderId} // ✅ Shows the value in the input
                      onChange={handleChange} // ✅ Updates value & triggers validation
                    />

                    <div className="relative">
                      <Button
                        type="submit"
                        loading={isLoading}
                        disabled={isLoading}
                        className="w-full mt-2 tracking-normal rounded-[10px] h-11 md:h-12 font-15px md:font-15px"
                        variant="formButton"
                      >
                        {translate('order-status', { ns: 'common' })}
                      </Button>
                    </div>
                    {!!isError && (
                      <Alert
                        message={translate('please-enter-correct-email', {
                          ns: 'trackorder',
                        })}
                      />
                    )}
                  </div>
                </form>
              </div>
            </div>
            <div className="w-full flex justify-end">
              <Image
                src={`/assets/images/trackorder_${COUNTRY_ID}.png`}
                alt="Track Order Image"
                width={400}
                height={400}
              />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
